const Backbone = require('backbone');
const FacetList = require('views/store/pages/categories/facet_list');
const FacetBanners = require('views/store/pages/categories/facet_banners');
const FacetLimitByResults = require('views/store/pages/categories/facet_limit_by_results');
const MenuView = require('views/store/common/menu');
const FacetHelper = require('lib/helpers/facet_helper');
const FacetCollection = require('app/collections/facets');

module.exports = Backbone.View.extend({
	el: '#page-content',

	events: {
		'click .js-view-results': '_viewResults',
		'click .js-reset-filters': '_resetFilters',
		'click .js-facet-underlay': '_toggleFacetMenu'
	},

	initialize(options = {}) {
		this.options = options;
		this.childViews = {};
		FacetHelper.mergeSelectedFacets(window.dataLayer);
		this.collection = new FacetCollection(window.dataLayer.facets, {
			getQueryParams: this.options.getQueryParams
		});

		this._initFacetListView();
		this._initFacetBannerView();
		this._initFacetLimitByResults();

		// *** tablet/mobile facet menu has 'reset filter' and 'view results' buttons
		this.$viewResultsButton = this.$('.js-view-results');
		this.$loadingOverlay = $('.overlay');

		// in case someone removes this view, kill some childViews
		this.listenTo(this, 'removeyourself', this._onViewTriggerRemove.bind(this));

		// triggered by facet.js anytime the selected facets change
		this.listenTo(this.collection, 'facets:collection:change', this._onFacetsChange.bind(this));
		this.listenTo(this.collection, 'update', this._onCollectionUpdate.bind(this));
		// *** since we're bootstrapped with window.dataLayer.facets instead of a fetch(), lets kick things off.
		this.collection.trigger('update');
	},

	_onViewTriggerRemove() {
		if (this.childViews.facetList) {
			this.childViews.facetList.remove();
		}
	},

	_onFacetsChange() {
		if (this.childViews.facetMenu && this.childViews.facetMenu.isOpen && window.BCOM.theme.isLivingDirect) {
			// when facet menu is open (tablet/mobile) the facets are fetched and the results are
			// shown just rendered in the menu. (User must then hit "apply" button to let page adjust to changes)
			this.collection.fetch({ isCollectionFetch: true });
		} else {
			this._updateFacets();
		}
	},

	_updateFacets() {
		if (typeof this.options.onFacetsChange === 'function') {
			this.options.onFacetsChange(this.collection.getSelectedFacets());
		}
	},

	_onCollectionUpdate() {
		if (this.$viewResultsButton.length) {
			this.$viewResultsButton.button('reset');
		}
		this._renderProductResultsCount();
		this._renderSelectedFacetGroupCount();
	},

	_initFacetListView() {
		if (this.options.facetListView && this.options.facetListView.enabled) {
			this.childViews.facetList = new FacetList({
				el: this.options.facetListView.el,
				collection: this.collection,
				startCollapsed: this.options.facetListView.startCollapsed
			});
		}

		// this is an LDI facet list displayed in a modal for tablet/mobile.
		if (this.options.facetListModal && this.options.facetListModal.enabled) {
			this.childViews.facetListModal = new FacetList({
				el: this.options.facetListModal.el,
				collection: this.collection,
				isFacetListWithSelects: true,
				startCollapsed: this.options.facetListModal.startCollapsed
			});
		}

		if (this.options.facetMenuView && this.options.facetMenuView.enabled) {
			this.childViews.facetMenu = new MenuView({
				openButton: '.js-narrow-results',
				menuContainer: '.js-facet-menu',
				// new tablet/mobile LDI facet close button should be coupled with js-facet-underlay
				closeContainer: this.options.facetMenuView.hasUnderlay ? '.js-facet-underlay' : '.js-facet-menu-close-container'
			});
		}
	},

	_initFacetBannerView() {
		if (!this.options.facetBannerView || !this.options.facetBannerView.enabled) {
			return;
		}
		this.childViews.facetBanners = new FacetBanners({
			el: this.options.facetBannerView.el || '.js-facet-banners',
			collection: this.collection
		});
	},

	_initFacetLimitByResults() {
		if (!this.options.limitByFacetResultsView || !this.options.limitByFacetResultsView.enabled) {
			return;
		}
		this.childViews.limitByFacetResults = new FacetLimitByResults({
			el: this.options.limitByFacetResultsView.el || '.js-facet-limit-by-results',
			collection: this.collection
		});
	},

	_toggleFacetMenu() {
		if (this.childViews.facetMenu && this.childViews.facetMenu.isOpen) {
			this.childViews.facetMenu.toggleMenu();
		}
	},

	_resetFilters() {
		this.collection.trigger('facets:groups:collapse');
		this.collection.trigger('facets:items:clearall');
	},

	_renderProductResultsCount() {
		const count = this.collection.info ? this.collection.info.countFormatted || this.collection.info.count : '';
		if (count && typeof count === 'number') {
			this.$('.js-num-results').text(window.BCOM.util.format.numberWithCommas(count));
		} else if (count) {
			this.$('.js-num-results').text(count);
		}
	},

	_viewResults() {
		if (window.BCOM.theme.isLivingDirect) {
			if (this.$viewResultsButton.length) {
				this.$viewResultsButton.button('loading');
			}
			this.showLoadingScreen();
			this._updateFacets();
		}
		this._toggleFacetMenu();
	},

	_renderSelectedFacetGroupCount() {
		const count = this.collection.getSelectedFacetItemsCount();
		this.$('.js-narrow-results').text(count === 0 ? 'Filter' : `Filter (${count})`);
	},

	/**
	 * ==================================================================================
	 * ************************ PUBLIC METHODS ************************************
	 * ==================================================================================
	 */

	getFacetQueries() {
		return this.collection.getFacetQueries();
	},

	getFacetTrackingString() {
		return this.collection.getFacetTrackingString();
	},

	showLoadingScreen() {
		this.$loadingOverlay.addClass('loading');
	},

	// Handler for isAsyncProductDrops functionality takes in new results from search.page.js fetch.
	updateFacetCollection(results) {
		this.collection.trigger('facets:fetch:results', results);
	}
});
